import React, { useState } from 'react';
import { HiOutlineHand } from 'react-icons/hi';
import './WelcomeTutorial.css';

const WelcomeTutorial = ({ onComplete, userGender }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const isMale = userGender === 'MALE';
  const isFemale = userGender === 'FEMALE';

  const steps = [
    {
      icon: <HiOutlineHand aria-hidden="true" />,
      title: 'Welcome to KwikLuv',
      description: 'Let\'s show you around. This will only take a minute.',
      highlight: 'No strings attached, just real connections.'
    },
    {
      title: 'Discover Profiles',
      description: 'Browse profiles in your area. Use filters to find exactly what you\'re looking for.',
      highlight: 'Message anyone for free'
    },
    {
      title: 'Start Chatting',
      description: 'Send unlimited messages for free. Reply to anyone who interests you.',
      highlight: 'You\'re in control'
    },
    {
      title: 'Video Calls',
      description: 'Start a video call right from the chat. The other person can accept or decline - just like a regular call.',
      highlight: 'Free video calls'
    },
    {
      title: 'Stay Safe',
      description: 'Use the Report button if you see anything concerning. Block users anytime.',
      highlight: 'We review all reports within 24 hours'
    },
    {
      title: 'You\'re All Set',
      description: 'Start exploring and making connections. Have fun and stay safe.',
      highlight: 'Everything is free'
    }
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete();
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  const step = steps[currentStep];
  const isLastStep = currentStep === steps.length - 1;

  return (
    <div className="tutorial-overlay">
      <div className="tutorial-modal">
        <div className="tutorial-content">
          {step.icon && <div className="tutorial-icon">{step.icon}</div>}
          
          <h2 className="tutorial-title">{step.title}</h2>
          
          <p className="tutorial-description">{step.description}</p>
          
          <div className="tutorial-highlight">
            <span style={{ opacity: 0.7 }}>{step.highlight}</span>
          </div>

          <div className="tutorial-progress">
            {steps.map((_, index) => (
              <div
                key={index}
                className={`progress-dot ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
              />
            ))}
          </div>

          <div className="tutorial-actions">
            {!isLastStep && (
              <button onClick={handleSkip} className="tutorial-btn tutorial-btn-skip">
                Skip
              </button>
            )}
            <button onClick={handleNext} className="tutorial-btn tutorial-btn-next">
              {isLastStep ? 'Get Started' : 'Next'}
            </button>
          </div>

          <div className="tutorial-step-counter">
            {currentStep + 1} of {steps.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeTutorial;
